module.exports = new __parcel__URL__("Warlock_49.cc32748c.png").toString();